import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestCardProcessingRatesWrapper from "@components/layouts/bestCardProcessingRatesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestCardProcessingRatesHome(): ReactElement {
    return (
        <BestCardProcessingRatesWrapper>
            <div className="max-w-7xl mx-auto block px-4vw lg:px-4">
                <PrivacyPolicy
                    category="Card Processing"
                    domain="BestCardProcessingRates.com"
                />
            </div>
        </BestCardProcessingRatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
